import { setTarget } from './event-data.js';
class EventListener {
    constructor(dataType) {
        this.dataType = dataType;
    }
    getConfig() {
        if (!this.config) {
            throw new Error('[EventListener]: listener is not configured.');
        }
        return this.config;
    }
    fire(event) {
        const config = this.getConfig();
        const eventDelegator = config.eventDelegator;
        const eventData = this.prepare(event);
        eventDelegator.fire(config.type, eventData);
    }
    listen(callback) {
        const config = this.getConfig();
        const eventBus = config.eventDelegator.eventBus;
        return eventBus.insert(config.type, callback);
    }
    prepare(data) {
        const { api } = this.getConfig();
        if (data instanceof this.dataType) {
            setTarget(data, api);
            return data;
        }
        const typedData = new this.dataType(data);
        setTarget(typedData, api);
        return typedData;
    }
}
function configureEventListener(instance, config) {
    instance.config = config;
}
export { configureEventListener, EventListener, };
//# sourceMappingURL=event-listener.js.map